var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGitt = function SvgIconGitt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 6.333a3 3 0 0 0 .785 2.023A1 1 0 0 0 4 9.333v2a1 1 0 0 0 1 1v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7a1 1 0 0 0 1-1v-2a1 1 0 0 0-.785-.977A3 3 0 0 0 17 3.333c-2.028 0-3.284 1.456-4 2.76q-.126.226-.232.451a1.493 1.493 0 0 0-1.535 0q-.108-.225-.232-.452C10.284 4.79 9.028 3.333 7 3.333a3 3 0 0 0-3 3m3-2a2 2 0 1 0 0 4h3.585a1.5 1.5 0 0 1-.04-.87 9 9 0 0 0-.42-.889C9.465 5.377 8.471 4.333 7 4.333m6.415 4a1.5 1.5 0 0 0 .04-.87 9 9 0 0 1 .42-.889c.659-1.197 1.653-2.241 3.125-2.241a2 2 0 0 1 0 4zm-.415 1v2h6v-2zm-2 0v2H5v-2zm-5 3h5v7H6zm7 7v-7h5v7z",
    clipRule: "evenodd"
  })));
};
export default SvgIconGitt;